import { useBreakpoint } from "gatsby-plugin-breakpoints";
import React from "react";
import styled from "styled-components";
import NavbarLeft from "./NavbarLeft";
import PluginsHeader from "./PluginsHeader";

const PluginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  width: 100%;
  /* background-color: red; */
  /* text-align: center; */
  padding-left: var(--spectrum-global-dimension-size-200);
  padding-right: var(--spectrum-global-dimension-size-200);
  padding-bottom: var(--spectrum-global-dimension-size-200);
  padding-top: var(--spectrum-global-dimension-size-200);

  @media (hover: hover) {
    padding-top: var(--spectrum-global-dimension-size-500);
  }

  h1.plugin {
    display: none;

    @media (min-width: 600px) {
      display: block;
      color: var(--spectrum-alias-heading-text-color);
      font-size: var(--spectrum-alias-heading-xl-text-size);
      font-weight: var(--spectrum-global-font-weight-regulat);
      /* margin: 15px auto; */
      margin: 0;
    }
  }

  h2.plugin {
    /* font-family: var(--spectrum-global-font-family-serif); */
    font-weight: var(--spectrum-global-font-weight-regular);
    font-size: var(--spectrum-alias-heading-s-text-size);
    margin-top: 0;
    @media (min-width: 600px) {
      font-size: var(--spectrum-alias-heading-s-text-size);
    }
    @media (min-width: 900px) {
      font-size: var(--spectrum-alias-heading-l-text-size);
      font-weight: var(--spectrum-global-font-weight-light);
    }
    /* font-style: italic; */
  }

  h3.plugin {
    @media (min-width: 900px) {
      font-size: var(--spectrum-alias-heading-m-text-size);
    }
  }

  /* @media (min-width: 600px) {
    h1.plugin {
      display: block;
      color: var(--spectrum-alias-heading-text-color);
      font-size: var(--spectrum-alias-heading-xl-text-size);
      font-weight: var(--spectrum-global-font-weight-regulat);
      margin: 0;
    }
  } */

  @media (min-width: 900px) {
    margin-top: 0;
    margin-left: 256px;
    width: calc(100vw - 256px);
    padding: var(--spectrum-global-dimension-size-500);
  }
`;
// Location is interesting, you can pass it down to any component (unclear how to
// pass it to main though) and can be used to drive behaviour based on route, see:
// https://stackoverflow.com/questions/61274365/allow-component-to-detect-route-change-in-gatsby
const PluginsLayout = ({ children }) => {
  const breakpoints = useBreakpoint();

  return (
    <>
      {breakpoints.tabletLandscapeUp === true ? (
        <NavbarLeft />
      ) : (
        <PluginsHeader />
      )}
      <PluginContainer>{children}</PluginContainer>
    </>
  );
};

export default PluginsLayout;
